import { useDialog, type IDialog } from "@/features/interface/dialog"
import { ConcurrencyException, type Fetch } from "../types"
import router from "@/router"

export function configConcurrency(nextFetch: Fetch): Fetch {
  return async function (input: RequestInfo | URL, init?: RequestInit) {
    if (init?.reloadPageOnConcurrencyException !== true) {
      return await nextFetch(input, init)
    }
    const response = await nextFetch(input, init)
    // Cas du 409
    if (response.status === 409) {
      const dialog: IDialog = useDialog()

      await dialog.showDialog({
        type: 'Error',
        title: 'Information',
        message: [
          "L'enregistrement a échoué, car le document a été modifié par un autre utilisateur.",
          "",
          "<strong>La page va être rechargée.</strong>"
        ],
        isHtml: true,
      })

      router.go(0)
      throw new ConcurrencyException()
    }

    return response
  }
}
